export default __webpack_public_path__ + "static/media/a13.feb270dd.jpg";